import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {MetricsConsentAutoCorrectionButtonStore} from '../../store/metricsConsentAutoCorrection/metricsConsentAutoCorrectionButton.store';
import {AppState} from '../../store/store';
import {Store} from '@ngrx/store';
import {
  selectMetricsConsentAutoCorrectionLoading,
  selectMetricsConsentAutoCorrectionStatus
} from '../../store/metricsConsentAutoCorrection/metricsConsentAutoCorrection.selectors';
import {AppService} from '../../services/app.service';
import {map} from "rxjs/operators";

@Component({
  selector: 'app-autocorrect-consent-button',
  templateUrl: './autocorrect-consent-button.component.html',
  styleUrls: ['./autocorrect-consent-button.component.scss'],
  providers: [MetricsConsentAutoCorrectionButtonStore],
  encapsulation: ViewEncapsulation.None
})
export class AutocorrectConsentButtonComponent implements OnInit, OnDestroy {
  public readonly loading$: Observable<boolean> = this._store.select(selectMetricsConsentAutoCorrectionLoading);
  public readonly status$: Observable<'not-configured' | 'off' | 'on'> = this._store.select(selectMetricsConsentAutoCorrectionStatus);
  public readonly enabled$: Observable<boolean> = this.status$.pipe(map((status: 'not-configured' | 'off' | 'on'): boolean => status == 'on'));

  constructor(
    // TODO appS à supprimer
    public readonly appS: AppService,
    private readonly _store: Store<AppState>,
    private readonly _metricsConsentAutoCorrectionButtonStore: MetricsConsentAutoCorrectionButtonStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public autocorrectToggle(): void {
    this._metricsConsentAutoCorrectionButtonStore.autocorrectToggle();
  }
}
